import { mailApiGet, mailApiPost } from "./client";
import type { MailColorLabel } from "@/lib/mail/messageLabels";

export type MessageLabelsResponse = {
  success: boolean;
  accountId: number;
  folder: string;
  labels: Record<string, { favorite: boolean; color: MailColorLabel | null }>;
};

export function fetchMessageLabels(params: { accountId: number; folder: string }) {
  const qs = new URLSearchParams();
  qs.set("accountId", String(params.accountId));
  qs.set("folder", params.folder);
  return mailApiGet<MessageLabelsResponse>(`imap/message-labels.php?${qs.toString()}`);
}

export function setMessageLabel(params: {
  accountId: number;
  folder: string;
  uid: number;
  favorite?: boolean;
  color?: MailColorLabel | null;
}) {
  const body: Record<string, unknown> = {
    accountId: params.accountId,
    folder: params.folder,
    uid: params.uid,
  };
  if (params.favorite !== undefined) body.favorite = params.favorite;
  if (params.color !== undefined) body.color = params.color;

  return mailApiPost<{
    success: boolean;
    uid: number;
    favorite: boolean;
    color: MailColorLabel | null;
  }>("imap/message-labels.php", body);
}

export function markMailMessageFlagged(params: {
  accountId?: number;
  folder?: string;
  uid: number;
  flagged: boolean;
}) {
  return mailApiPost<{ success: boolean; uid: number; flagged: boolean }>(
    "imap/mark-flagged.php",
    {
      accountId: params.accountId,
      folder: params.folder ?? "INBOX",
      uid: params.uid,
      flagged: params.flagged,
    }
  );
}
